import React, { CSSProperties } from "react";
import { Spin } from "antd";
import NS from "../utils/NS";

export default function NSStatusHandler({
  status,
  children,
  style,
}: {
  status: NS;
  style?: CSSProperties;
  children: () => any;
}) {
  if (status.isInit) return null;
  if (status.isSuccess) return children();

  if (status.isLoading || status.isError) {
    return (
      <div
        className="nsstatus-handler"
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          color: "inherit",
          ...style,
        }}
      >
        {status.isLoading && <Spin />}
        {status.isError && "Oops! Something went wrong."}
      </div>
    );
  }

  return null;
}
